import React from 'react'

const Footer = () => {
  return (
    <>
      <div className="absolute bottom-[2%] w-[100%] font-sora text-center text-[#ffe0e059]  list-none md:pr-24 md:text-right lg:bottom-[4%] hidden md:block">
        @ TeamXTech 2024
      </div>
    </>
  )
}

export default Footer
